import React from 'react';
import * as PropTypes from 'prop-types';

import {FormGroup} from './style';
import {TextArea} from 'semantic-ui-react';

const TextAreaForm = ({input, label, placeholder, meta: {touched, error, warning}}) => {
    return (
        <FormGroup>
            <label>{label}</label>
            <TextArea
                {...input}
                placeholder={placeholder}
            />
            {
                touched &&
                (
                    (error && <output>{error}</output>) ||
                    (warning && <output>{warning}</output>)
                )
            }
        </FormGroup>
    )
};

TextAreaForm.propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object
};

export default TextAreaForm;